"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScaleitConfirmDialogResult;
(function (ScaleitConfirmDialogResult) {
    ScaleitConfirmDialogResult[ScaleitConfirmDialogResult["Close"] = 0] = "Close";
    ScaleitConfirmDialogResult[ScaleitConfirmDialogResult["No"] = 1] = "No";
    ScaleitConfirmDialogResult[ScaleitConfirmDialogResult["Yes"] = 2] = "Yes";
})(ScaleitConfirmDialogResult = exports.ScaleitConfirmDialogResult || (exports.ScaleitConfirmDialogResult = {}));
